export default
[
  "1-sertifikat-vidpovidnosti-na-sistemu-upravlinnya-yakistyu-1.jpeg",
  "3-rishennya-pro-zatverdzhennya-postachalnika-1.jpeg",
  "dokument0.jpeg",
  "dozvil-na-pochatok-roboti-1.jpeg",
  "dozvil-№05.15.30-1.jpg",
  "dozvil-№0176.15.12-1.jpg",
  "dozvil-№246.13.30-1.jpg",
  "dozvil-№246.13.30-2.jpg",
  "dozvil-№0503.16.12-1.jpg",
  "dozvil-№0504.16.12-1.jpg",
  "dozvil-№1300.14.12-1.jpg",
  "dozvil-№1301_14_12_1.jpg",
  "liczenziya-perelik-vidiv-robit-1.jpeg",
  "liczenziya-perelik-vidiv-robit-2.jpeg"
]